


















import Vue from 'vue';
import Component from 'vue-class-component';
import { HalfWidthBlocksViewModel, HeroBannerViewModel, JsonContent } from '@/types/contentServerContract';
import { Prop } from 'vue-property-decorator';
import ContentBlockContainer from '@/project/app/blocks/ContentBlockContainer.vue';

interface JsonContentWithUniqueKey extends JsonContent{
    _uid: number;
}

@Component({
    components: { ContentBlockContainer }
})
export default class HalfWidthBlocks extends Vue {
    private failingBlocks: number[] = [];

    @Prop({
        required: true,
        type: Object
    }) content!: HalfWidthBlocksViewModel;

    @Prop(String) alias!: string;

    @Prop({ required: true, type: Boolean })
    isFirstBlock!: boolean;

    // Vimeo videos are not allowed to be cropped, therefor we always respect their aspect ratio
    // and then the sibling has to use flexbox to align to its height
    private isSiblingVimeoVideo(index: number) {
        const siblingIndex = index % 2 === 0 ? index + 1 : index - 1;
        const sibling = this.blocks[siblingIndex]?.content as HeroBannerViewModel;
        return sibling && !!sibling.vimeoVideoId;
    }

    get appendToPreviousBlock() {
        return this.content.appendToPreviousBlock && !this.isFirstBlock;
    }

    private get blocks(): JsonContentWithUniqueKey[] {
        return this.content?.blocks?.map((b, ix) => {
            return ({
                ...b,
                _uid: ix
            });
        }) ?? [];
    }

    private get filteredBlocks(): JsonContentWithUniqueKey[] {
        return this.blocks.filter(b => !this.failingBlocks.includes(b._uid));
    }

    private contentLoadError(uid: number) {
        this.failingBlocks.push(uid);
    }
}
